import { CodeReviewTechnicalDetailsModel } from "./code-review-technical-details-model";
import { CodeReviewerModel } from "./code-reviewer-model";

export class CodeReviewModel {
    _id: string;
    deleted: number;
    project_id: string;
    created_by: string;
    created_time: number;
    last_updated_by: string;
    last_updated_time: number;
    title: string;
    artifact_report_id: string;
    artifact_id: string;
    artifact_type: string;
    artifact_name: string;
    approved: boolean;
    state: string;
    closed_time: number;
    merged_time: number;
    code_review_linkage_ids: string[];
    code_review_technical_details_mappings: { [key: string]: CodeReviewTechnicalDetailsModel };
    reviewers: { [key: string]: CodeReviewerModel };
    comments: string[];
}